import { render, staticRenderFns } from "./List2.vue?vue&type=template&id=2724eccd&scoped=true"
import script from "./List2.vue?vue&type=script&lang=js"
export * from "./List2.vue?vue&type=script&lang=js"
import style0 from "./List2.vue?vue&type=style&index=0&id=2724eccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724eccd",
  null
  
)

export default component.exports